export const iconFontAwesomeArrowsRightToBracket = (
	<i className="fa-solid fa-right-to-bracket"></i>
);
